<template>
 <div class="container" v-if="isAdmin">
   <h1>Events</h1>
   <div class="event-header">
      <div class="event-id">
        ID
      </div>
      <div class="event-title">
        TITLE
      </div>
      <div class="event-owner">
        OWNER
      </div>
      <div class="event-status">
        STATUS
      </div>
      <div class="event-actions">
        ACTIONS
      </div>
   </div>
   <div v-for="event in allEvents" :key="event.id" class="event-items">
      <div class="event-id">
        {{event._id}}
      </div>
      <div class="event-title">
        {{event.title}}
      </div>
      <div class="event-owner">
        <router-link :to="`/user/${owner(event.team).userName}`">
          {{owner(event.team).displayName}}
        </router-link>
      </div>
      <div class="event-status">
        {{event.status}}
      </div>
      <div class="event-actions">
        <router-link :to="{ name: 'event-view', params: { eventId: event._id }, }"
          tag="button" class="button-secondary">
          Preview
        </router-link>
        <button @click="setStatus(event._id, 'active')" class="button-success">
          Set Active Status
        </button>
        <button @click="setStatus(event._id, 'draft')" class="button-error">
          Set Draft Status
        </button>
      </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'admin-events',
  data() {
    return {
      allEvents: [],
      isAdmin: false,
    };
  },
  async mounted() {
    try {
      const adminEventsResponse = await this.backendAxios.get('/admin/events');
      this.allEvents = adminEventsResponse.data;
      this.isAdmin = true;
    } catch (err) {
      this.$toasted.show(err.response.data, {
        type: 'info',
        duration: 5000,
      });
      this.$router.push('/');
    }
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
    owner: () => team => team.filter(({ role }) => role === 'owner')[0].user || {},
  },
  methods: {
    async setStatus(eventId, status) {
      this.$toasted.show('Are you sure you want to change the status?', {
        type: 'info',
        duration: 0,
        action: [{
          text: 'Yes',
          onClick: async (e, t) => {
            try {
              await this.backendAxios.post(`/admin/events/${eventId}/${status}`);
              this.$router.go();
            } catch (err) {
              this.$toasted.show(err.response.data, {
                type: 'info',
                duration: 5000,
              });
            }
            t.goAway(0);
          },
        }, {
          text: 'No',
          onClick: (e, t) => t.goAway(0),
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
}

.event-items, .event-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  text-align: left;
  padding-bottom: 1rem;
  & * {
    overflow: auto;
  }
}

.event-header {
  font-weight: bold;
}

.event-id {
  width: 15%;
}

.event-title {
  width: 15%;
}

.event-owner {
  width: 15%;
}

.event-status {
  width: 5%;
}

.event-actions {
  width: 30%;
}

.button-success,
.button-error,
.button-warning,
.button-secondary {
    color: white;
    font-weight: 500;
    border-radius: 4px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    font-size: 1rem;
    margin: 0 0.5rem 0 0;
    padding: 0.5rem;
    cursor: pointer;
    &:hover {
      filter: brightness(1.2);
    }
}

.button-success {
    background: rgb(28, 125, 0); /* this is a dark green */
}

.button-error {
    background: rgb(202, 60, 60); /* this is a maroon */
}

.button-warning {
    background: rgb(223, 117, 20); /* this is an orange */
}

.button-secondary {
    background: rgb(0, 38, 255); /* this is a dark blue */
}

</style>
